import {createApp, h} from 'vue'
import {InertiaProgress} from '@inertiajs/progress'
import {createInertiaApp} from '@inertiajs/inertia-vue3'
import moment from 'moment'
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import {createPinia} from "pinia";




InertiaProgress.init()
const pinia = createPinia()



createInertiaApp({
    resolve: name => require(`./Pages/${name}`),
    title: title => title ? `${title} - Mjengo Tracker` : 'Mjengo Tracker',
    setup({el, App, props, plugin}) {

        let app = createApp(
            {
                render: () => h(App, props)
            });
        app.config.globalProperties.$moment = moment
        app.use(plugin)
        app.use(pinia)
        app.component('date-picker', Datepicker);
        app.mount(el)


    },


});


